export default __webpack_public_path__ + "static/media/Payment_successfull.b7ca4385.png";